import React, { useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { IAppState } from 'model/IAppState';
import * as rdEnum from 'helpers/enum';

/*import { buttonClickLog } from 'services/Member';*/

import {
    IImagesState,
    getImageLinkByID2,
    getMobileImageLinkByID2,
    getCMSAssets,
    getServiceUrlPara
} from 'helpers/Uri';

import { isNil } from 'lodash';
import moment from 'moment';
import { useBrandWebsiteLinks } from 'helpers/useBrandWebsiteLinks';

export const Footer = (props: any) => {
    const brandWebsiteLinks = useBrandWebsiteLinks();

    const {pageName} = props;

    const navigate = useNavigate();
    
    const [isOpen, setIsOpen] = useState(false);

    const selectedDeliveryFromStore = useSelector((state: IAppState) => {
        return state.selectedDelivery;
    });

    const handleActionOpen = () => {
        setIsOpen(!isOpen);
    }

    const loginSession = useSelector((state: IAppState) => {
        return state.session;
    });

    const toLatestNews = () => {
        let url = brandWebsiteLinks.getNewsLink();
        window.open(url, '_blank');
    }
    const toRegister = () => {
        let url = brandWebsiteLinks.getRegisterLink();
        window.open(url, '_blank');
    } 
    const towhyCadillac = () => {
        let url = brandWebsiteLinks.getWhyCadillacLink();
        window.open(url, '_blank');
    } 
    
    const toEVLife = () => {
        let url = brandWebsiteLinks.getEVLifeLink();
        window.open(url, '_blank');
    } 
    const toContactUs = () => {
        let url = brandWebsiteLinks.getContactUsLink();
        window.open(url, '_blank');
    } 


    const toWorld = () => {
        let url = brandWebsiteLinks.getContactUsLink();
        window.open(url)
    }
    const toCopyright = () => {
        let url = brandWebsiteLinks.getCopyRight();
        window.open(url)
    }
    const toPrivacyPolicy = () => {
        let url = brandWebsiteLinks.getPrivacyLink();
        window.open(url)
    }

    const toFacebook = () => {
        window.open('https://www.facebook.com/people/Cadillac/100093522254859/')
    }
    const toInstagram = () => {
        window.open(' https://www.instagram.com/cadillacanz/')
    }

    return (
        <div className="footer-container">
                                        
            <div className="footer ">

                <div className='footer-logo-container page-container-content'>
                    <img alt="" src={`${getCMSAssets()}/footer/Cadillac.svg`} />
                </div>

                <div className='footer-content-container'>

                    <div className='footer-get-updates-container'>
                        <div className='checkout-btn-panel'>
                            <Button className='checkout-btn' onClick={() => toRegister()}>
                                GET UPDATES
                            </Button>
                        </div>
                    </div>

                    <div className='footer-links-icons-container'>
                        <div className='footer-links-container'>
                            <a className='link-item' onClick={() => towhyCadillac()}>
                                WHY CADILLAC
                            </a>
                            <a className='link-item' onClick={() => toRegister()}>
                                REGISTER INTEREST
                            </a>
                            <a className='link-item' onClick={() => toEVLife()}>
                                YOUR EV LIFE
                            </a>
                            <a className='link-item' onClick={() => toContactUs()}>
                                CONTACT US
                            </a>
                            <a className='link-item' onClick={() => toLatestNews()}>
                                CADILLAC NEWS
                            </a>
                        </div>
                        <div className='footer-icons-container'>
                            <p>FOLLOW US</p>
                            <div className='footer-icons-panel'>
                                <div className='icon-item' onClick={() => toInstagram()}>
                                    <img alt="" src={`${getCMSAssets()}/footer/Instagram.svg`} />
                                </div> 
                                <div className='icon-item' onClick={() => toFacebook()}>
                                    <img alt="" src={`${getCMSAssets()}/footer/Facebook.svg`} />
                                </div> 

                            </div>
                            
                            {/* <div className='icon-item'>
                                <img alt="" src={`${getCMSAssets()}/footer/Youtube.svg`} />
                            </div>  */}
                        </div>
                    </div>
                    
                </div>
            </div>

            {
                pageName == '' 
                ?
                <div className='disclaimer-container'>
                    <div className='disclaimer-content-container'>
                        <div className='disclaimer-title'>Disclaimers</div>
                        <div className='disclaimer-card-container'>
                            <div className='disclaimer-card'>
                                <div className='disclaimer-card-title'>
                                    Driveaway Price<sup>1</sup>
                                </div>
                                {
                                    selectedDeliveryFromStore.Country?.code == rdEnum.enumCountryCode.Australia
                                    ?
                                    <div className='disclaimer-content'>
                                        This is the drive away price for the selected country, state or territory. It is based on the owner being a ‘rating one’ driver aged 40 with a good driving record. The drive away price displayed is inclusive of the vehicle purchase price, goods and services tax (GST), luxury car tax (LCT), stamp duty, compulsory third party insurance, registration, a plate fees and a GST-inclusive regional delivery fee if applicable. The final drive away price may differ depending on your individual circumstances. The price does not take into account any valid discount, rebate or promotion that may be available from time to time. Each country, state or territory may offer additional registration types which are not covered in this configurator, therefore your individual situation may vary and have an impact on the final Drive Away price. Cadillac reserves the right to vary the Drive away price at its discretion, including for changes in specifications or features. The final Drive Away price will be provided to you upon checkout.
                                    </div>
                                    :
                                    <div className='disclaimer-content'>
                                        <sup>1</sup>This is the drive away price for the selected country, state or territory. The drive away price displayed is inclusive of the vehicle purchase price, goods and services tax (GST), compulsory third party insurance, registration, a plate fees and a GST-inclusive regional delivery fee if applicable. The final drive away price may differ depending on your individual circumstances. The price does not take into account any valid discount, rebate or promotion that may be available from time to time. Each country, state or territory may offer additional registration types which are not covered in this configurator, therefore your individual situation may vary and have an impact on the final Drive Away price. Cadillac reserves the right to vary the Drive away price at its discretion, including for changes in specifications or features. The final Drive Away price will be provided to you upon checkout.
                                    </div>
                                }
                            
                            </div>
                            <div className='disclaimer-card'>
                                <div className='disclaimer-card-title'>
                                    Vehicle Availability<sup>2</sup>
                                </div>
                                <div className='disclaimer-content'>
                                    Availability and delivery dates are estimates only. Many factors impact vehicle delivery. Cadillac reserves the right to make changes to availability and delivery dates displayed throughout this configurator without notice.
                                </div>
                            </div>
                            <div className='disclaimer-card'>
                                <div className='disclaimer-card-title'>
                                    Range<sup>3</sup>
                                </div>
                                <div className='disclaimer-content'>
                                    Based on a full charge. The range of electric vehicles is determined using a uniform measurement procedure (WLTP). Range and energy consumption may vary under real-world conditions depending on driving style and various external factors. It is therefore not always possible to achieve the range according to WLTP. 
                                </div>
                            </div>
                            <div className='disclaimer-card'>
                                <div className='disclaimer-card-title'>
                                    Charge to 80%<sup>4</sup>
                                </div>
                                <div className='disclaimer-content'>
                                    Based on a 2025 LYRIQ charging with a compatible 190kW DC charger. Actual charge times will vary based on battery condition, output of charger, vehicle settings and outside temperature. See the vehicle's Owner's Manual for additional limitations. 
                                </div>
                            </div>
                            <div className='disclaimer-card'>
                                <div className='disclaimer-card-title'>
                                    0-100 km/h<sup>5</sup>
                                </div>
                                <div className='disclaimer-content'>
                                    <p style={{marginBottom: '.5rem'}}>Figures based on GM testing in the United States in controlled environments. Actual figures may vary and are subject to environmental conditions.</p>
                                    Vehicles shown throughout this experience are simulated local production vehicles intended for illustrative purposes. Cadillac has taken reasonable steps to ensure your digital configuration replicates the vehicle you receive in real life. Colours and other features may appear different in real life.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <></>
            }

            {
                pageName != ''
                ?
                <div className="copyright-container">
                    {/* <p className="copyright">© 2024 GENERAL MOTORS. ALL RIGHTS RESERVED.</p> */}
                    <p className="copyright">
                        <span className='copyright-link'>
                            © 2024 GENERAL MOTORS. ALL RIGHTS RESERVED.
                        </span>
                        &nbsp;
                        <span className='copyright-link' onClick={() => toWorld()}>
                            CADILLAC WORLDWIDE
                        </span> &nbsp;
                        <span className='copyright-link' onClick={() => toPrivacyPolicy()}> 
                            PRIVACY POLICY
                        </span> &nbsp;
                        <span className='copyright-link' onClick={() => toCopyright()}>
                            COPYRIGHT &amp; TRADEMARK
                        </span> 
                        
                        {/* <span className='copyright-link' onClick={() => toWorld()}>
                            CADILLAC WORLDWIDE
                        </span> | &nbsp;
                        <span className='copyright-link' onClick={() => toCopyright()}>
                            COPYRIGHT &amp; TRADEMARK
                        </span> |&nbsp;
                        <span className='copyright-link' onClick={() => toPrivacyPolicy()}> 
                            PRIVACY POLICY
                        </span>  */}
                    </p>
                </div>
                :
                <></>
            }
{/* 
            <div className="footer page-container-content">
                <Row className='footer-items-container'>
                    <Col lg={4} className='footer-items-img-box'>
                    </Col>
                    <Col lg={1}>
                    </Col>
                    <Col lg={6}>
                        <Row>
                            <Col lg={4} className='footer-item-card'>
                                <h5>VEHICLE</h5>

                                <p>LYRIQ</p>
                                <p>Configure</p>
                                <p>Test Drive</p>
                                <p>Charge</p>
                            </Col>
                            <Col lg={4} className='footer-item-card'>
                                <h5>CADILLAC</h5>

                                <p>About us</p>
                                <p>Business offering</p>
                            </Col>
                            <Col lg={4} className='footer-item-card'>
                                <h5>CONTACT</h5>

                                <p>Help & Support</p>
                                <p>Newsroom</p>
                            </Col>
                        </Row>
                        
                    </Col>
                </Row>

                <Row className='footer-copyright-container'>

                </Row>
                
                <Row className='footer-disclaimers-container'>

                </Row>
            </div> */}
                
        </div>
    );
        
    
};




